import { calculateDistance, getOperatingStatus, isBookmarked } from './storage.js';

export function filterTouristCenters(allCenters, options = {}) {
  const {
    query = '',
    province = '',
    city = '',
    languages = {},     // { en: bool, ja: bool, zh: bool }
    facilities = {},    // { luggage: bool, wheelchair: bool, wifi: bool, interpretation: bool, stamp: bool }
    openOnly = false,
    bookmarkedOnly = false,
    userLocation = null // { lat, lng }
  } = options;

  const normalizedQuery = query.trim().toLowerCase();

  let results = allCenters.filter(center => {
    // 1. Text search
    if (normalizedQuery) {
      const targetText = `${center.name} ${center.address} ${center.province} ${center.city} ${center.intro} ${center.services} ${center.locationDesc}`.toLowerCase();
      if (!targetText.includes(normalizedQuery)) {
        return false;
      }
    }

    // 2. Province filter
    if (province && province !== 'all' && center.province !== province) {
      return false;
    }

    // 3. City filter
    if (city && city !== 'all' && center.city !== city) {
      return false;
    }

    // 4. Languages filter
    if (languages.en && !center.languages.en) return false;
    if (languages.ja && !center.languages.ja) return false;
    if (languages.zh && !center.languages.zh) return false;

    // 5. Facilities filter
    if (facilities.luggage && !center.facilities.luggage) return false;
    if (facilities.wheelchair && !center.facilities.wheelchair) return false;
    if (facilities.wifi && !center.facilities.wifi) return false;
    if (facilities.interpretation && !center.facilities.interpretation) return false;
    if (facilities.stamp && !center.facilities.stamp) return false;

    // 6. Open Only filter
    if (openOnly) {
      const op = getOperatingStatus(center);
      if (op.status !== 'open') return false;
    }

    // 7. Bookmarked filter
    if (bookmarkedOnly && !isBookmarked(center.id)) {
      return false;
    }

    return true;
  });

  // Calculate distance if user location is provided
  if (userLocation && userLocation.lat && userLocation.lng) {
    results = results.map(center => {
      const dist = calculateDistance(userLocation.lat, userLocation.lng, center.lat, center.lng);
      return { ...center, distance: dist };
    });

    results.sort((a, b) => {
      if (a.distance === null) return 1;
      if (b.distance === null) return -1;
      return a.distance - b.distance;
    });
  }

  return results;
}

export function extractProvincesAndCities(allCenters) {
  const provinceMap = {};

  allCenters.forEach(center => {
    const prov = center.province || '기타';
    const cty = center.city || '';

    if (!provinceMap[prov]) {
      provinceMap[prov] = new Set();
    }
    if (cty) {
      provinceMap[prov].add(cty);
    }
  });

  const formatted = Object.keys(provinceMap).sort().map(prov => ({
    province: prov,
    cities: Array.from(provinceMap[prov]).sort()
  }));

  return formatted;
}
